import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import useSlabVsUsedPoints from "./useSlabVsUsedPoints";

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const SlabVsEarnedPoints = (props) => {
  const { graphData=[] } = useSlabVsUsedPoints(props);
 
  const validData = graphData && graphData?.filter(
    (item) => item.slab && !isNaN(parseInt(item.pointsusedbyslab, 10))
  );
  //const validData=graphData;
  // Get the maximum value for dynamic scaling
  const maxValue = Math.max(...validData.map((item) => parseInt(item.pointsusedbyslab, 10)), 0);

  const data = {
    labels: validData.map((item) => item.slab),
    datasets: [
      {
        label: "Used Points",
        data: validData.map((item) => parseInt(item.pointsusedbyslab, 10)),
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Slab vs Used Points",
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.raw.toLocaleString()} points`;
          },
        },
      },
      datalabels: {
        display: true,
        align: "end",
        anchor: "end",
        formatter: (value) => `${value.toLocaleString()}`,
        color: "#000",
        font: {
          weight: "bold",
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Tier Slabs",
        },
      },
      y: {
        beginAtZero: true,
        max: Math.ceil(maxValue / 50000) * 50000, // Round up to the nearest 10k
        title: {
          display: true,
          text: "Used Points (in Lakh)",
        },
        ticks: {
          stepSize: 50000,
          callback: function (value) {
            return `${value / 1000}L`; // Format tick labels
          },
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default SlabVsEarnedPoints;
